export default __webpack_public_path__ + "static/media/score-card.48a740b2.png";